(() => {
  const initializeAos = () => {
    if (typeof window.AOS === 'undefined') return;

    window.AOS.init({
      disable: () => window.matchMedia('(prefers-reduced-motion: reduce)').matches,
      duration: 600,
    });
  };

  const refreshAos = () => {
    if (typeof window.AOS === 'undefined') return;

    window.requestAnimationFrame(() => window.AOS.refreshHard());
  };

  initializeAos();
  document.addEventListener('shopify:section:load', refreshAos);
})();
